enum UsoApp {
    Rede = 1,
    Franquia = 2,
}

export default UsoApp;
